let cache = {}

export default {
  getPrice(city) {
    return new Promise(resolve => {
      $.get('/api/delivery/price', {city}, response => {
        resolve(response)
      })
    })
  },
  getSdekPoints(city) {
    return new Promise(resolve => {
      $.get('/api/delivery/sdek-points', {city}, response => {
        resolve(response)
      })
    })
  },
  getCourierMskPrice({latitude, longitude}) {
    return new Promise(resolve => {
      $.get('/api/delivery/courier-msk-price', {latitude, longitude}, response => {
        resolve(response)
      })
    })
  },
}
